import { Carousel as BaseCarousel, CarouselView as BaseCarouselView } from "@lernetz/ui-components/src/carousel/Carousel";
import { View, ViewConfig } from "@lernetz/ts-lib/src/view/View";
import template from "./Carousel.html";
import imageTemplate from "./Image.html";
import leftTemplate from "./leftTemplate.html";
import rightTemplate from "./rightTemplate.html";
import {Image} from './../image/Image';

export class Carousel extends BaseCarousel {
    constructor(dto) {
        super();
        this.items = dto.images;
        this.currentItem = dto.images[0];
    }
}

export class CarouselView extends BaseCarouselView {


    constructor( config?: ViewConfig<BaseCarousel> ) {
        super( { ...config, template } );
        this.registry.add('ControlLeft', () => new View({template: leftTemplate }) );
        this.registry.add('ControlRight', () => new View({template: rightTemplate }) );
        this.registry.add(Image, () => new View({template: imageTemplate }) );

    }

    init() {

        // this.data.propertyChange.filter( arg => arg.name == 'currentItem' ).subscribe( () => {
        //     this.resizeHeight();
        // } );
        //
        // this.resizeHeight();

    }

    private resizeHeight() {
        setTimeout( () => {
            const imageNode = this.node.querySelector( '.content img' ) as HTMLImageElement;
            const contentNode = this.node.querySelector( '.content' ) as HTMLElement;
            contentNode.style.height = `${imageNode.getBoundingClientRect().height}px`;
        }, 1000 );

    }

}
